import RafTimer from './RafTimer.js'
import fpsLimiter from './fpsLimiter.js'
import raf from './raf.js'

export { RafTimer, fpsLimiter, raf }
export default raf



//////////////////
// WEBPACK FOOTER
// ./node_modules/raf/lib/index.js
// module id = 88
// module chunks = 0